import React, { ReactElement } from 'react';

import { Icon } from '@iconify/react';

import router from '~/core/router';
import { settingsSidebar } from '~/core/sidebar';
import {
  PersonalInformationRoute,
  SubscriptionRoute,
} from '~/modules/settings';

router.addPrivateRoutes([PersonalInformationRoute, SubscriptionRoute]);

settingsSidebar.addItems({
  a: [
    {
      key: 'personal_information',
      path: PersonalInformationRoute.path,
      getTitle: PersonalInformationRoute.getTitle,
      Icon: (props): ReactElement => (
        <Icon {...props} icon="material-symbols:person-outline" />
      ),
    },
    {
      key: 'subscription',
      path: SubscriptionRoute.path,
      getTitle: SubscriptionRoute.getTitle,
      Icon: (props): ReactElement => (
        <Icon {...props} icon="material-symbols:card-membership-outline" />
      ),
    },
  ],
});
